import { useState } from 'react';
import { AppTable } from '../../../components/AppTable';
import { BodyContainer } from '../../../elements';
import { InventoryListHook } from '../../../hooks/inventory';
import {
  InventoryExpirationPopup,
  InventoryExpirationRow,
} from '../../../page-components';
import { useGlobalContext } from '../../../contexts';

export function ExpirationListScreen() {
  const [adjustmentItem, setAdjusmentItem] = useState(null);
  const { warehouseId } = useGlobalContext();

  const openAdjustmentPopup = item => {
    setAdjusmentItem(item);
  };

  const closeAdjustmentPopup = () => {
    setAdjusmentItem(null);
  };

  const {
    data,
    loading,
    totalData,
    totalPages,
    filter,
    filterChanged,
    pageChanged,
    refresh,
  } = InventoryListHook(warehouseId, true);

  const columns = [
    {
      text: 'Product Description',
      key: 'description',
      width: 3,
      textAlign: 'left',
    },
    {
      text: 'Location',
      key: 'location',
      width: 2,
      textAlign: 'left',
    },
    {
      text: 'Expiry Date',
      key: 'expiry_date',
      width: 2,
      textAlign: 'center',
    },
    {
      text: 'Units Expiring',
      key: 'units_expiring',
      width: 1,
      textAlign: 'left',
    },
    {
      text: 'Lots',
      key: 'lots',
      width: 2,
      textAlign: 'left',
    },
    {
      text: '',
      key: 'action',
      width: 3,
      textAlign: 'left',
    },
  ];

  return (
    <BodyContainer className="no-header">
      <AppTable
        columns={columns}
        data={data}
        loading={loading}
        totalData={totalData}
        totalPages={totalPages}
        RowComponent={<InventoryExpirationRow openPopup={openAdjustmentPopup} />}
        currentPage={filter.page}
        pageSizeChanged={size => filterChanged('limit', size)}
        pageSize={filter.limit}
        pageChanged={pageChanged}
      />
      <InventoryExpirationPopup
        onClose={closeAdjustmentPopup}
        open={!!adjustmentItem}
        item={adjustmentItem}
        refresh={refresh}
        warehouseId={warehouseId}
      />
    </BodyContainer>
  );
}
